<template>
    <app-modal :modal-id="modalId" :preloader="preloader" @close-modal="closeModal" modal-size="full-width">
        <template slot="header">
            <h5 class="modal-title" id="exampleModalLabel">
                {{ $t('change_selected_trucks_position') }}
            </h5>
            <button type="button" class="close outline-none" @click.prevent="closeModal">
                <span class="mb-1">
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
        <template slot="body">
            <app-overlay-loader v-if="preloader" />
            <form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form" data-url='trucks-position'>
                <div class="row">
                    <div class="col-md-12">
                        <table class="table table-xs table-hover">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>
                                        <app-input class="w-100" id="location" v-model="inputs.location_id"
                                            :list="locationList" list-value-field="name" type="search-select"
                                            :required="true" @input="locationChanged" />
                                    </th>
                                    <th>
                                        <app-input class="w-100" id="escorter" v-model="inputs.status_id"
                                            :list="statusList" list-value-field="name" type="search-select"
                                            :required="true" @input="statusChanged" />
                                    </th>
                                    <th></th>
                                    <th></th>
                                </tr>
                                <tr style="background-color: #f1f5fa;">
                                    <th>{{ $t('horse_number') }} - {{ $t('lot_number') }}</th>
                                    <th>{{ $t('current_location') }}</th>
                                    <th>{{ $t('current_status') }}</th>
                                    <th>{{ $t('current_escorter') }}</th>
                                    <th>{{ $t('comment') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(trip, index) in inputs.trips" :key="index">
                                    <td>
                                        <strong>{{ trip.horse }} - {{ trip.lot_number }}</strong>
                                    </td>
                                    <td>
                                        <app-input class="w-100" :id="`location-${trip.id}`" v-model="trip.location_id"
                                            :list="locationList" list-value-field="name" type="search-select" />
                                    </td>
                                    <td>
                                        <app-input class="w-100" :id="`status-${trip.id}`" v-model="trip.status_id"
                                            :list="statusList" list-value-field="name" type="search-select" />
                                    </td>
                                    <td>
                                        <app-input class="w-100" :id="`escorter-${trip.id}`" v-model="trip.escorter_id"
                                            :list="escorterList" list-value-field="name" type="search-select" />
                                    </td>
                                    <td>
                                        <app-input class="w-100" :id="`comment-${trip.id}`" v-model="trip.tracking_comment" type="text" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="event_date">{{ $t('event_date') }} <span style="color: crimson">*</span></label>
                            <div class="d-flex align-items-center w-100">
                                <app-input class="w-100" id="event_date" v-model="inputs.event_date" type="date"
                                    :required="true" />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="event_time">{{ $t('event_time') }} <span style="color: crimson">*</span></label>
                            <div class="d-flex align-items-center w-100">
                                <app-input class="w-100" id="event_time" v-model="inputs.event_time" type="time"
                                    :required="true" />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="inputs_comment">{{ $t('comment') }}</label>
                            <app-input id="inputs_comment" type="text" v-model="inputs.comment"
                                :placeholder="$t('comment')" />
                        </div>
                    </div>
                </div> -->
            </form>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal" @click="closeModal">
                {{ $t('cancel') }}
            </button>
            <button type="button" class="btn btn-primary" @click="submit">
                {{ $t('save') }}
            </button>
        </template>
    </app-modal>
</template>

<script>
import { mapState } from 'vuex';
import { FormMixin } from '../../../../core/mixins/form/FormMixin';
import { ModalMixin } from '../../../Mixins/ModalMixin';

export default {
    name: 'BulkTruckEventModal',
    mixins: [FormMixin, ModalMixin],
    props: {
        tableId: {
            type: String,
        },
        trips: {
            type: Array,
        },
    },
    computed: {
        ...mapState({
            locationList: state => state.selects.locationList,
            statusList: state => state.selects.statusList,
            escorterList: state => state.selects.escorterList,
        }),
    },
    data() {
        return {
            inputs: {
                location_id: null,
                status_id: null,
                trips: [],
            },
            preloader: false,
            modalId: 'bulk-truck-event-modal',
            isModalActive: false,
        }
    },
    methods: {
        locationChanged(event) {
            for (let i = 0; i < this.inputs.trips.length; i++) {
                this.inputs.trips[i].location_id = event;
            }
        },
        statusChanged(event) {
            for (let i = 0; i < this.inputs.trips.length; i++) {
                this.inputs.trips[i].status_id = event;
            }
        },
        submit() {
            this.save({
                ...this.inputs,
                trips: this.inputs.trips.map((trip) => ({
                    id: trip.id,
                    location_id: trip.location_id,
                    status_id: trip.status_id,
                    escorter_id: trip.escorter_id,
                    comment: trip.tracking_comment || null,
                })),
            });
        },
        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            this.$hub.$emit('reload-' + this.tableId);
        },
    },
    mounted() {
        this.$store.dispatch('getLocations');
        this.$store.dispatch('getStatus');
        this.$store.dispatch('getEscorters');
        this.inputs.trips = this.trips.map((trip) => ({ ...trip }));
    }
}
</script>

<style></style>
